export class User {
  id: number;
  email: string;
  name: string;
  vendorId: number;

  constructor(id: number, email: string, vendorId: number, name?: string) {
    this.id = id;
    this.email = email;
    this.vendorId = vendorId;
    this.name = name;
  }
}
